export default {
  'base.setup.title': '系统初始化',
  'base.setup.subtitle': '设置管理员账号，完成后即可登录使用',
  'base.setup.usernameLabel': '管理员用户名',
  'base.setup.usernamePlaceholder': '请输入管理员用户名',
  'base.setup.usernameRequired': '请输入管理员用户名',
  'base.setup.usernameMin': '用户名至少 2 个字符',
  'base.setup.emailLabel': '邮箱',
  'base.setup.emailPlaceholder': '输入邮箱（选填）',
  'base.setup.emailInvalid': '邮箱格式不正确',
  'base.setup.passwordLabel': '登录密码',
  'base.setup.passwordPlaceholder': '至少 6 个字符',
  'base.setup.passwordRequired': '请设置登录密码',
  'base.setup.passwordMin': '密码至少 6 个字符',
  'base.setup.confirmLabel': '确认密码',
  'base.setup.confirmPlaceholder': '再次输入密码',
  'base.setup.confirmRequired': '请再次输入密码',
  'base.setup.confirmMismatch': '两次输入的密码不一致',
  'base.setup.submit': '完成初始化',
  'base.setup.success': '初始化成功，请登录',
  'base.setup.failed': '初始化失败',
}
